<template>
  <qx-card title="轨迹查询">
    <MapTrack ref="trackMap" />
  </qx-card>
</template>

<script>
import {
  trackOrderQuery,
  trackingInTransit,
} from 'api/operate';
import MapTrack from 'components/mapTrack';
export default {
  components: {
    MapTrack,
  },
  data () {
    return {
      loading: false,
      data: null,
      lons: null,
    };
  },
  watch: {
    '$route.query.orderId': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/operate/track/trackDetail' || !this.$route.query.orderId) {
        return;
      }
      this.loading = true;
      // 在途-轨迹查询
      this.lons = await trackingInTransit({
        orderId: this.$route.query.orderId,
      });
      this.data = await trackOrderQuery({
        orderId: this.$route.query.orderId,
      });

      this.$nextTick(() => {

        if (this.lons.items.length) {
          this.$refs.trackMap.setTrack(this.lons);
        } else {
          this.$refs.trackMap.setTrack(this.data);
        }
        this.loading = false;
      });
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
